import { useLazyQuery } from "@apollo/client"
import { ORDER_TYPES } from "data/orderTypes"
import { DELIVERY_METHODS } from "data/static.items"
import { useOrderFilterVariables } from "graphql/dispatch/dispatch.hooks"
import { AGGREGATED_ORDER_ITEMS } from "graphql/order/order.queries.gql"
import useSearchParams from "hooks/useSearchParams"
import { useEffect, useState } from "react"
import { useCurrentDc } from "store/auth.redux"
import { ApolloErrorToast } from "utils/AppToaster"
import BaseEncoder from "utils/base-encoder"

export const useAddOrder = () => {
  const [params] = useSearchParams()
  const orderStrings = params.ords
  const total = params.total

  const [distributionCenter] = useCurrentDc()
  const orderFilter = useOrderFilterVariables()

  const [order, setOrder] = useState<any>({
    user: null,
    date: new Date(),
    orderItems: [
      {
        quantity: "",
      },
    ],
    pickupSlots: [{}],
    shippingMethod: DELIVERY_METHODS?.[0]?.id,
  })
  const [getData] = useLazyQuery(AGGREGATED_ORDER_ITEMS, {
    onCompleted({ aggregatedOrderItems }) {
      setOrder(prev => ({
        ...prev,
        orderItems: aggregatedOrderItems,
      }))
    },
    onError: ApolloErrorToast,
  })
  const targetDcId = order?.targetDcId?.id

  useEffect(() => {
    const orders = BaseEncoder.decode(orderStrings)
      ?.split(",")
      .map(a => parseInt(a))
      .filter(a => a)

    if ((orders && orders.length > 0) || (total && total > 0)) {
      setOrder(prev => ({
        ...prev,
        orderCategory: ORDER_TYPES.filter(o => o.id === "T0")[0],
      }))
    } else {
      setOrder(prev => ({
        ...prev,
        orderCategory: ORDER_TYPES.filter(o => o.id === "T2")[0],
      }))
    }

    if (targetDcId && order?.orderCategory?.id !== "T2") {
      getData({
        variables: {
          orderIds: orders,
          targetDcId,
          orderingDcId: distributionCenter.id,
          filter: orderFilter,
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderStrings, getData, targetDcId])

  return [order, setOrder, distributionCenter] as const
}
